// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1eh5g","toggle":"styles_toggle__EWT4u","preview":"styles_preview__NQ68J"};